import React, { Component } from 'react';
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'

import { InputText } from 'primereact/inputtext';
import { Button } from "primereact/button";
import * as UserService from '../service/user.service';
import { ProgressSpinner } from 'primereact/progressspinner';
import FacebookLogin from 'react-facebook-login';
import { GoogleLogin } from 'react-google-login';
import { ToggleButton } from 'primereact/togglebutton';
import {ScrollPanel} from 'primereact/scrollpanel';

class PrivacyPolicy extends Component {

	constructor(props) {
		super(props);

		this.state = {
			
		};
	}
	privacy(){
		return <div style={{ marginBottom: '10%',paddingLeft: '7px'}}>
		<h3>นโยบายคุ้มครองสิทธิความเป็นส่วนตัวของ ซี-ซาเล้ง</h3>
							<text>      &emsp;บริษัท แก้วกรุงไทย จำกัด (“บริษัทฯ”) ซึ่งประกอบกิจการและกำกับดูแลตลาดออนไลน์ภายใต้ชื่อ “C3Leng” ในประเทศไทยแต่เพียงผู้เดียว คำนึงถึงมาตราการปกป้องข้อมูลทุกรูปแบบที่บริษัทฯ มีในครอบครองทั้งหมดตามกฎหมายต่างๆ ที่เกี่ยวข้อง
		บริษัท แก้วกรุงไทย จำกัด ในฐานะผู้ควบคุมข้อมูลตามกฎหมาย มีสำนักงานตั้งอยู่เลขที่ 589 อาคารวิชชุวรรณ ชั้นที่ 2 ถนนรัชดาภิเษก แขวงดินแดง เขตดินแดง กรุงเทพมหานคร 10400 
		นโยบายความเป็นส่วนตัว (“นโยบาย”) นี้ ชี้แจงรายละเอียดเกี่ยวกับการได้มา การใช้/ประมวลผล และการเก็บรักษา ข้อมูลของผู้ใช้บริการ C3Leng ของบริษัทฯ เท่านั้น<br></br></text>
		<text>      &emsp;บริษัทฯ ให้ความสำคัญเกี่ยวกับความโปร่งใสในการดำเนินธุรกิจและการให้บริการต่อสมาชิกหรือผู้ใช้บริการ C3Leng ในฐานะเจ้าของข้อมูล (“คุณ”) นโยบายความเป็นส่วนตัวนี้ใช้บังคับเกี่ยวกับข้อมูลที่บริษัทฯ เก็บรวบรวมและรักษาไว้ โดยอธิบายครอบคลุมถึงประเภท วัตถุประสงค์ และวิธีปฏิบัติเกี่ยวกับการใช้ประมวลผลและการเก็บรักษาข้อมูลต่างๆ อันได้แก่ ไอพีแอดเดรส (IP Address) คุกกี้ (Cookies) และ/หรือข้อมูลส่วนบุคคลที่คุณมอบให้ผ่านเว็บไซต์และแอพพลิเคชั่นของบริษัทฯ ขณะที่ลงทะเบียนและใช้บริการ C3Leng ซึ่งรวมถึง ข้อมูล Facebook และ/หรือ Google Account ของคุณ
		คุณมีหน้าที่ต้องอ่านและรับทราบนโยบายนี้ทั้งหมดก่อนที่จะให้ข้อมูลใดๆ กับบริษัทฯ  การใช้เว็บไซต์หรือแอพพลิเคชั่น C3Leng หรือลงทะเบียนการขอใช้บริการและกิจกรรมอื่นๆ ของเรา โดยคุณจะต้องให้ความยินยอมผ่านการแสดงเจตนาโดยชัดแจ้งหรือโดยนัยในการอนุญาตให้บริษัทฯ รวบรวม ใช้และเก็บรักษาข้อมูลของคุณตามที่กำหนดไว้ตามนโยบายนี้
		หากคุณมีข้อสงสัยเกี่ยวกับแนวทางปฏิบัติตามนโยบายความเป็นส่วนตัวนี้ รวมถึงข้อกังวลหรือข้อร้องเรียนเกี่ยวกับข้อมูลของคุณประการใด โปรดติดต่อโดยส่งเป็นจดหมายหรือคำร้องผ่านทางอีเมลมาที่ adminc3leng@c3leng.com
		ข้อมูลที่บริษัทฯรวบรวม</text>
		<h3>แหล่งข้อมูล</h3>
		<text>      &emsp;บริษัทฯรวบรวมข้อมูลเกี่ยวกับคุณหรือข้อมูลเกี่ยวกับอุปกรณ์การใช้งานของคุณจากคุณโดยตรงเท่านั้น ตราบเท่าที่คุณอนุญาตโดยชัดแจ้งหรือโดยนัยให้เราใช้ประมวลผลและเก็บรักษาข้อมูลดังกล่าวผ่านทาง</text>
		<text>
			&ensp;•	เว็บไซต์ C3Leng<br></br>
			&ensp;•	แอปพลิเคชั่น C3Leng<br></br>
			&ensp;•	Facebook (ข้อมูลบัญชีสมาชิกที่เป็นสาธารณะ)<br></br>
			&ensp;•	Google Account (ข้อมูลบัญชีสมาชิกที่เป็นสาธารณะ)<br></br>
			&ensp;•	อุปกรณ์ของผู้ใช้ (คอมพิวเตอร์ และ/หรือ โทรศัพท์มือถือ)<br></br>
		</text>
		<h3>ประเภทของข้อมูล</h3>
		<text>จากแหล่งข้อมูลข้างต้น ข้อมูลที่บริษัทฯจะเก็บรวบรวมมีดังนี้<br></br></text>
		<text>	

		&ensp;•	ชื่อ<br></br>
		&ensp;•	นามสกุล<br></br>
		&ensp;•	รูปภาพโปรไฟล์ / ภาพถ่าย<br></br>
		&ensp;•	ที่อยู่อีเมล์<br></br>
		&ensp;•	ชื่อบัญชี C3Len Application<br></br>
		&ensp;•	ชื่อและรหัสผ่านสำหรับบัญชีสมาชิก C3Leng<br></br>
		&ensp;•	ที่อยู่<br></br>
		&ensp;•	หมายเลขโทรศัพท์<br></br>
		&ensp;•	Facebook (member_id, public_profile)<br></br>
		&ensp;•	Google Account (member_id, public_profile)<br></br>
		&ensp;•	เนื้อหาหรือข้อมูลเกี่ยวกับการโพสต์สินค้าบนแพลตฟอร์มของ C3Leng<br></br>
		&ensp;•	คุกกี้<br></br>
		&ensp;•	ไอพีแอดเดรส (IP Address)<br></br>
		&ensp;•	ตำแหน่งทางภูมิศาสตร์<br></br>
		&ensp;•	เนื้อหาหรือข้อมูลในเครื่องมือแชทที่มีอยู่บน C3Leng<br></br>

		<h3>วิธีการเก็บรวบรวมข้อมูล</h3>
		เราเก็บรวบรวมข้อมูลเกี่ยวกับคุณ ดังต่อไปนี้<br></br>
		<text>
			&ensp;•	ในขณะที่คุณกรอกข้อมูลเพื่อการลงทะเบียนเปิดบัญชีสมาชิก C3Leng หรือดูแลปรับปรุงข้อมูลบัญชีสมาชิกของคุณ หรือขอรับบริการต่าง ๆ บนแพลตฟอร์ม C3Leng<br></br>
			&ensp;•	การลงทะเบียนบัญชีสมาชิก C3Leng บริษัทฯจะเก็บรวบรวมข้อมูลเฉพาะที่คุณได้ให้ในแบบฟอร์มที่แสดงอยู่บนแพลตฟอร์มเท่านั้น<br></br>
			&ensp;•	การเลือกลงทะเบียนบัญชีสมาชิก C3Leng โดยให้เชื่อมต่อกับบัญชีสมาชิก Facebook หรือ Google ของคุณ บริษัทฯจะเก็บรวบรวมข้อมูลโปรไฟล์จากบัญชีสมาชิก Facebook หรือ Google เฉพาะส่วนที่คุณเปิดเผยแก่สาธารณะ โปรดทราบว่าบริษัทฯไม่จัดเก็บหรือรับรู้รหัสผ่านเข้าบัญชีสมาชิก Facebook หรือ Google ของคุณในระบบข้อมูลของบริษัทฯแต่อย่างใด<br></br>
			&ensp;•	ข้อมูลเกี่ยวกับสินค้า คำบรรยายสินค้า รูปภาพ ที่ผู้ใช้งานได้ให้หรือปรากฏบนแพลตฟอร์มของ C3Leng<br></br>
			&ensp;•	ข้อมูลการสนทนาหรือข้อความระหว่างผู้ใช้งานที่ปรากฏในระบบสนทนา บนแพลตฟอร์ม C3Leng<br></br>
			</text>
		<br></br>
		บริษัทฯรวบรวมข้อมูลเกี่ยวกับอุปกรณ์ของคุณ ดังต่อไปนี้<br></br>
		&ensp;•	เมื่อคุณใช้เว็บไซต์หรือแอพพลิเคชั่น C3Leng บริษัทฯจะเก็บรวบรวมและวิเคราะห์ข้อมูลบางอย่างโดยอัตโนมัติซึ่งรวมถึงเบราว์เซอร์ที่ชี้เฉพาะเจาะจง ที่อยู่ IP และข้อมูลเกี่ยวกับระบบปฏิบัติการ อุปกรณ์ที่ชี้เฉพาะเจาะจง (เช่น Apple IDFA หรือ Android Advertising ID) ตำแหน่งทางภูมิศาสตร์และข้อมูลที่ชี้เฉพาะถึงอุปกรณ์อื่น ๆ ข้อมูลเกี่ยวกับอินเทอร์เน็ต รวมถึงรายละเอียดเกี่ยวกับธุรกรรมของคุณที่เกิดขึ้นบนเว็บไซต์และแอพ C3Leng<br></br>

		<h3>การใช้คุกกี้และเทคโนโลยีอื่น ๆ</h3>
		<text>&emsp;บริษัทฯ และบุคคลที่สามใช้เทคโนโลยีเพื่อเก็บรวบรวมข้อมูลเกี่ยวกับการใช้งานของคุณที่เกิดขึ้นบนเว็บไซต์และแอพ C3Leng</text>
			<text>
			&ensp;•	คุกกี้และเทคโนโลยีอื่น ๆ เพื่อการเก็บข้อมูล คุกกี้และเทคโนโลยีอื่น ๆ เพื่อการจัดเก็บ หมายความถึงไฟล์ที่มีข้อมูลเฉพาะของอุปกรณ์ที่ทางบริษัท ฯ หรือบุคคลที่สามได้ส่งถึงหรืออ่านได้จากอุปกรณ์ของคุณซึ่งจะบันทึกจดจำอุปกรณ์ดังกล่าวเพื่อวัตถุประสงค์ในการให้บริการ การบันทึก การวิเคราะห์พฤติกรรมและทางการตลาด  บริษัท ฯ และบุคคลที่สามจะใช้วิธีการอัตโนมัติในการอ่านหรือบันทึกข้อมูลอุปกรณ์ของคุณ ซึ่งรวมถึงคุกกี้ประเภทต่าง ๆ และเบราว์เซอร์ทั้งหลาย หรือปลั๊กอินอื่น ๆ (เช่นที่เก็บ HTML5 หรือฐานข้อมูลแบบ Flash) โดยคุณอาจเลือกที่จะตั้งค่าเว็บเบราว์เซอร์ของคุณให้ปฏิเสธการให้จัดเก็บคุกกี้บางประเภทหรือจัดให้มีการเตือนในกรณีที่มีการส่งคุกกี้บางประเภทได้ ซึ่งเบราว์เซอร์บางชนิดอาจสามารถถูกตั้งค่าที่คล้ายกันในแบบ HTML5 และ Flash ได้ อย่างไรก็ตามหากคุณป้องกันหรือปฏิเสธการให้จัดเก็บคุกกี้หรือที่เก็บข้อมูลในพื้นที่เว็บไซต์ของบริษัทฯ อาจส่งผลต่อการทำงานของเว็บไซต์ C3Leng ได้<br></br>
			&ensp;•	เทคโนโลยีอื่น ๆ ในการเก็บข้อมูล  บริษัทฯใช้เทคโนโลยีอัตโนมัติมาตรฐานต่าง ๆ ในการเก็บข้อมูลเช่นเว็บบีคอน (หรือเรียกว่า clear GIFs หรือพิกเซลแท็ก) หรือเทคโนโลยีที่คล้ายคลึงกันเพื่อการติดต่อหรือสื่อสารผ่านทางคุกกี้ต่าง ๆ และเพื่อติดตามผลการใช้งานของคุณบนเว็บไซต์และ/หรือแอพของบริษัทฯ นอกจากนี้บริษัทฯยังใช้เว็บบีคอนกับข้อความในอีเมล์เพื่อติดตามผลว่าคุณเปิดอ่านข้อความ รวมถึงการใช้งานอื่น ๆ ดังต่อไปนี้ <br></br>
			</text>
			<text>&emsp;ในบางกรณีบริษัทฯอาจใช้ข้อมูลดังกล่าวเพื่อการโฆษณาที่ดำเนินการโดยบุคคลที่สาม ซึ่งจะใช้วิธีการเก็บรวบรวมข้อมูลโดยอัตโนมัติ เช่นคุกกี้ ที่จะติดตามการใช้งานบนเว็บไซต์ของคุณเป็นช่วงๆไป โดยข้อมูลดังกล่าว รวมถึงข้อมูลเกี่ยวกับการเข้าชมเว็บไซต์หรือแอพพลิเคชั่นต่างๆ และข้อมูลอื่นๆ ที่บริษัทฯได้รับ อาจถูกใช้เพื่อปรับการเสนอโฆษณาที่เหมาะสมตรงกับความสนใจหรือคุณลักษณะเฉพาะตัว<br></br></text>
			<text>&emsp;อย่างไรก็ดี คุณสามารถควบคุมจัดการที่เกี่ยวกับโฆษณาและการวิเคราะห์ที่นำเสนอโดย Google ได้ที่ https://adssettings.google.com/ และ https://tools.google.com/dlpage/gaoptout ซึ่งการจัดการ เปลี่ยนแปลงหรืออัปเกรดเบราว์เซอร์ของคุณหรือการลบคุกกี้ออกจากระบบดังกล่าว อาจต้องทำผ่านวิธีการเลือกไม่รับ (opt-out) อีกขั้นตอนหนึ่ง ซึ่งการต่อสัญญาณที่ไม่ได้ติดตามบนเบราว์เซอร์ดังกล่าวอยู่นอกเหนือความรับผิดชอบของบริษัทฯ<br></br></text>
			<text>&emsp;สำหรับการควบคุมจัดการความเป็นส่วนตัวเกี่ยวกับอุปกรณ์สื่อสารไร้สายของคุณ โปรดตรวจสอบรายละเอียดคำแนะนำเกี่ยวกับวิธีใช้การควบคุมความเป็นส่วนตัวเพิ่มเติมใดๆ ที่ระบบปฏิบัติการมือถือของคุณนำเสนอเช่นการตั้งค่าความเป็นส่วนตัวสำหรับตัวระบุอุปกรณ์และตำแหน่งทางภูมิศาสตร์ได้ด้วยตนเองที่เว็บไซต์ของผู้ผลิตอุปกรณ์อุปกรณ์สื่อสารไร้สายของคุณ <br></br></text>
			
		<h3>ลิงค์ของบุคคลที่สาม</h3>
			•	เว็บไซต์และแอปพลิเคชันของ C3Leng อาจมีลิงก์ของเว็บไซต์อื่นๆ (“บุคคลที่สาม”) ซึ่งไม่อยู่ภายใต้การดูแลของบริษัทฯ คุณควรตรวจสอบนโยบายความเป็นส่วนตัวของเว็บไซต์ของบุคคลที่สามอย่างละเอียดก่อน การนำเสนอลิงก์ของบุคคลที่สามนั้น มีไว้เพื่อความสะดวกที่ผู้ใช้บริการของบริษัทฯสามารถค้นหาข้อมูลเพิ่มเติมเกี่ยวกับหัวข้อบางอย่าง โดยบุคคลที่สามนั้นไม่ได้ให้หรือแชร์ข้อมูลใดๆ ของคุณกับบริษัทฯแต่อย่างใด ดังนั้นบริษัทฯไม่มีความรับผิดชอบต่อการปกป้องความเป็นส่วนตัวหรือเนื้อหาของเว็บไซต์ของบุคคลที่สาม ไม่ว่าบางส่วนหรือทั้งหมด
		 
		<h3>บริษัทฯใช้ข้อมูลที่รวบรวมอย่างไร</h3>
		<text>&emsp;บริษัทฯใช้หรือเปิดเผยข้อมูลของคุณเฉพาะด้วยความยินยอมโดยนัยหรือโดยชัดแจ้งที่ระบุไว้ในระเบียบข้อบังคับของกฎหมายที่บังคับทั้งหมดในเขตอำนาจศาลที่เกี่ยวข้องเท่านั้น ตามวัตถุประสงค์ดังต่อไปนี้<br></br></text>
		<text>	
			&ensp;•	เพื่อวัตถุประสงค์ทางธุรกิจของบริษัทฯ บริษัทฯจะใช้และเก็บข้อมูลเพื่อประมวลผล วิเคราะห์และปรับปรุงธุรกิจของบริษัทฯ ซึ่งรวมถึงจัดสรรบริการบนแพลตฟอร์ม C3Leng<br></br>
			&ensp;•	เพื่อการรักษาความปลอดภัยทางไซเบอร์ บริษัทฯใช้หรือวิเคราะห์ข้อมูลในการตรวจสอบพฤติกรรมหรือกิจกรรมที่อาจผิดกฎหมายเพื่อการป้องกันการฉ้อโกงหรืออาชญากรรมต่างๆ <br></br>
			&ensp;•	เพื่อส่งข้อมูลข่าวสารเกี่ยวกับธุรกิจบางอย่างของบริษัทฯให้แก่คุณ รวมถึงการประชาสัมพันธ์ การส่งเสริมการขาย การเปลี่ยนแปลงนโยบายต่างๆ ของแพลตฟอร์มและการสื่อสารทางการตลาด<br></br>
			&ensp;•	เพื่อการปรับแต่งเนื้อหาและการโฆษณาที่คุณพบเห็นบนเว็บไซต์และแอพของบริษัทฯผ่านทางอินเทอร์เน็ตและที่อื่นๆ<br></br>
			</text>

		<h3>การเปิดเผยข้อมูลที่บริษัทฯรวบรวม</h3>
		<text>	
			&ensp;•	บริษัทฯอาจแบ่งปันข้อมูลตามกฎหมายหรือคำขออย่างเป็นทางการของหน่วยงานของรัฐ<br></br>
			&ensp;•	บริษัทฯอาจแบ่งปันข้อมูลที่ไม่อาจระบุตัวตนของคุณกับบริษัทในเครือของบริษัทฯ ซึ่งถือเป็นส่วนหนึ่งในการดำเนินธุรกิจตามปกติของบริษัทฯ
			</text>
		<h3>ระยะเวลาการเก็บข้อมูล</h3>
			<text>&emsp;บริษัทฯจะเก็บรักษาข้อมูลต่างๆ ตราบเท่าที่จำเป็นในการดำเนินธุรกิจของบริษัทฯ หรือตามที่กำหนดไว้ตามกฎหมายของประเทศไทย ซึ่งโดยปกติเป็นระยะเวลา 2 ปีหลังจากนับตั้งแต่เมื่อมีการปิดหรือลบบัญชีสมาชิกหรือตามระยะเวลาที่กำหนดโดยกฎหมายที่เกี่ยวข้อง เมื่อครบกำหนดเวลาดังกล่าว บริษัทฯจะลบข้อมูลนั้นออกจากฐานข้อมูลของบริษัทฯ<br></br></text>
			<text>&emsp;อย่างไรก็ดี คุณอาจใช้สิทธิเพื่อปกป้องความเป็นส่วนตัวของคุณที่จะขอลบหรือทำลายข้อมูลของคุณจากฐานข้อมูลของบริษัทฯได้ โดยทำคำขอเป็นลายลักษณ์อักษรส่งถึงบริษัทฯที่อีเมล์ adminc3leng@c3leng.com</text>
		 
		<h3>การปรับปรุงและแก้ไขนโยบายนี้</h3>
			<text>&emsp;บริษัท แก้วกรุงไทย จำกัด ขอสงวนสิทธิ์ตามดุลยพินิจแต่เพียงผู้เดียวในการเปลี่ยนแปลง แก้ไขหรือลบบางส่วนของนโยบายนี้ได้ตลอดเวลา โปรดติดตามตรวจสอบการเปลี่ยนแปลงหรือแก้ไขเพิ่มเติมนโยบายความเป็นส่วนตัวนี้บนหน้าเว็บไซต์และแพลตฟอร์ม C3Leng <br></br></text>
			<text>&emsp;การที่คุณใช้งานหรือบริการบนเว็บไซต์ต่อไปหลังจากที่มีการเปลี่ยนแปลงหรือแก้ไขเพิ่มเติมนโยบายนี้ ถือว่าคุณได้แสดงเจตนาตกลงยอมรับเงื่อนไขไม่เฉพาะแต่เพียงบางส่วน แต่ทั้งหมด</text>
		<br></br>
		<br></br>
		<br></br>
		นโยบายนี้ปรับปรุงล่าสุดและมีผลใช้บังคับตั้งแต่วันที่ 9 เมษายน 2563<br></br>
		</text>
		</div>
	}

	render() {
		const privacy = this.privacy()
		return (
			<div className="login-body" >
				<div className="p-grid">
					
					<div className="p-col-12">


						<div className="card card-w-title" style={{ marginRight: '10%',marginTop: '2%'}}>
							<div className="login-panel-content">
								<div className="p-grid">

									<div className="p-col-9 p-md-10 p-lg-10">
										<h2 className="welcome-text">นโยบายความเป็นส่วนตัว</h2>
									</div >

									<div className="p-col-3 p-md-2 p-lg-2" style={{ textAlign: 'right'}}>
										<a href="">หน้าหลัก</a>
									</div>
									<ScrollPanel style={{width: '100%', height: '500px'}}>
										{privacy}
									</ScrollPanel>
								</div>
							</div>
						</div>

					</div>
				</div>
			</div>
		)
	}
}

const mapStateToProps = (state) => ({
	

})

const mapDispatchToProps = dispatch => ({



})


export default
	connect(
		mapStateToProps,
		mapDispatchToProps, null, { forwardRef: true })(PrivacyPolicy)